/**
 * 比例字符串解析（画布媒体占位框用）。
 *
 * '16:9' / '9:16' / '1:1' / '4:3' / '3:4' 等来自生图 / 生视频节点的设置，
 * 'auto' / 'adaptive' 或非法值返回 fallback（由调用方决定兜底比例）。
 */

/** 解析 'W:H' 形式的比例字符串为数值（宽/高）；无法解析时返回 fallback */
export function parseAspectRatioValue(value: string | null | undefined, fallback: number): number {
  if (!value) return fallback;
  const match = /^(\d+(?:\.\d+)?)\s*:\s*(\d+(?:\.\d+)?)$/.exec(value.trim());
  if (!match) return fallback;
  const w = Number(match[1]);
  const h = Number(match[2]);
  return w > 0 && h > 0 ? w / h : fallback;
}
